import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import MenuItem from "app/containers/Features/components/MemberSelection/MenuItem";
import {
  MemberSelectionProps
} from "app/containers/Features/components/MemberSelection/types";
import React, { useEffect, useRef, useState } from "react";

const Index: React.FC<MemberSelectionProps> = ({
  trigger,
  selectedValue,
  updateValue,
  align,
  className,
  dropdownContainerClassName,
  headingText,
  onClose,
  searchPlaceholder,
  containerClassName,
  onOpen,
  handleSelectAll,
  options,
  isFullWidth,
  dropdownWidthClassName,
  hideRole, // hide role text
  hideSearchIcon, // hide search icon
  headerAreaClassName, // header area class name
  inputNoBorder,
  headingTextClassName,
  showSearch = true,
  isMultiSelect = false,
  arrowClassName,
  showTooltipArrowIcon = false,
  onLoadMore,
  hasMore,
  isLoading,
  isExternalSearch = false,
  externalOnSearchChange,
  externalSearchValue,
  isMoreLoading = false,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState(
    dropdownWidthClassName ?? 0,
  );
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (containerRef.current) {
      setDropdownWidth(containerRef.current.offsetWidth);
    }
  }, []);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);

    if (isOpen) {
      onOpen?.();
    } else {
      onClose?.();
    }
  };
  return (
    <div ref={containerRef} className={`relative w-full ${containerClassName}`}>
      <DropdownMenu.Root open={open} onOpenChange={handleOpenChange}>
        <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <MenuItem
            options={options}
            onChange={updateValue}
            dropdownWidth={dropdownWidth}
            value={selectedValue}
            align={align}
            headingText={headingText}
            isFullWidth={isFullWidth}
            searchPlaceholder={searchPlaceholder}
            className={className}
            menuContentClassName={dropdownContainerClassName}
            isMultiSelect={isMultiSelect}
            handleSelectAll={() => handleSelectAll?.()}
            hideRole={hideRole}
            hideSearchIcon={hideSearchIcon}
            headerAreaClassName={headerAreaClassName}
            inputNoBorder={inputNoBorder as boolean}
            headingTextClassName={headingTextClassName}
            showSearch={showSearch}
            arrowClassName={arrowClassName}
            showTooltipArrowIcon={showTooltipArrowIcon}
            onLoadMore={onLoadMore}
            hasMore={hasMore}
            isLoading={isLoading}
            isExternalSearch={isExternalSearch}
            externalOnSearchChange={externalOnSearchChange}
            externalSearchValue={externalSearchValue}
            isMoreLoading={isMoreLoading}
          />
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
};

export default Index;
